export var getApiError = function (error, keyName) {
    var _a, _b, _c, _d;
    var errors = (_d = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[keyName]) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.errors;
    if (errors && errors.length > 0) {
        var _e = errors[0], errorCode = _e.errorCode, errorMessage = _e.errorMessage;
        return { errorCode: errorCode, errorMessage: errorMessage };
    }
    return { errorCode: '', errorMessage: '' };
};
